
import { ParallaxEffect, ParallaxContext } from '../ParallaxEffect';
import { BaseParallaxEffect } from '../BaseParallaxEffect';

export class MistDriftEffect extends BaseParallaxEffect implements ParallaxEffect {
    public render(pc: ParallaxContext): void {
        const { ctx, layerIndex, config, time, width } = pc;
        const spacing = (500 + layerIndex * 200) / (config.parallaxPatternDensity || 1.0);
        const { y1, y2 } = this.getGridBounds(pc, spacing );
        const curTime = time * 0.5 * config.parallaxSpeed;
        const scale = config.parallaxScale || 1.0;

        for (let y = y1; y <= y2; y += spacing) {
            const driftX = (time * 50 * (1 + layerIndex * 0.2)) % (width * 4);
            const h = spacing * 0.8 * scale;
            const w = width * 2;
            
            const draw = () => {
                const grad = ctx.createLinearGradient(0, y - h/2, 0, y + h/2);
                grad.addColorStop(0, 'transparent');
                grad.addColorStop(0.5, pc.color);
                grad.addColorStop(1, 'transparent');
                
                ctx.fillStyle = grad;
                ctx.save();
                ctx.translate(driftX - width * 2, 0);
                ctx.globalAlpha *= 0.5;
                ctx.fillRect(-w, y - h/2, w * 2, h);
                ctx.restore();
            };
            draw();
            this.applyGlow(pc, draw);
        }
    }
}
